import { Body1 } from "@iventis/styles";
import React, { useEffect, useState } from "react";
import { useCadRotation } from "../../state/hooks/use-cad-rotation";
import { ControlContainer } from "./map-zoom";

export function RotationCad() {
    const { rotation, setRotation } = useCadRotation();
    const [inputValue, setInputValue] = useState(rotation.toFixed(2));

    // Keep input in sync if rotation changes externally
    useEffect(() => {
        // Only update input if the rotation changed outside of typing
        setInputValue((prev) => {
            const asNumber = Number.parseFloat(prev);
            // If the input is not a number or doesn't match the external rotation, update
            if (Number.isNaN(asNumber) || asNumber !== rotation) {
                return rotation.toString();
            }
            return prev;
        });
    }, [rotation]);

    const handleInputChange = (valStr: string) => {
        setInputValue(valStr);
        const valNumber = Number.parseFloat(valStr);
        if (!Number.isNaN(valNumber)) {
            if (valNumber > 360) {
                setRotation(0);
                return;
            }
            if (valNumber < 0) {
                setRotation(360);
                return;
            }
            setRotation(valNumber);
        }
    };

    return (
        <ControlContainer>
            <Body1>Rotation </Body1>
            <input className="number-input" type="number" value={inputValue} onChange={(event) => handleInputChange(event.target.value)} />
        </ControlContainer>
    );
}
